import { Button, Modal } from 'antd'
import { forwardRef, Fragment, useImperativeHandle, useRef } from 'react'
import { useState } from 'react'
import styles from './index.scss'
import wechatImg from '@/common/images/icon/weixin.png'
import gerlunImg from '@/common/images/icon/gel_logo_wechat.png'
import WechatBind from './wechat-bind'
import User from '@/modules/user'
const WechatVerify = (props, ref) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [wechatInfo, setWechatInfo] = useState(null)
  const wechatBindRef = useRef(null)
  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(
    ref,
    () => ({
      open
    }),
    []
  )
  const open = (info) => {
    setWechatInfo({ ...info })
    setModalVisible(true)
  }
  const handleRegister = () => {
    setModalVisible(false)
    props.registerClick()
  }
  const handleBind = () => {
    console.log({ wechatInfo })
    setModalVisible(false)
    wechatBindRef.current.open({ ...wechatInfo })
  }
  const handleWechatBinded = async(res) => {
    console.log({ binded: res })
    const user = new User()
    await user.handleUserInfo(res)
    props.setStatu(user.getLoginStatu())
  }
  return (
    <Fragment>
      <Modal
        destroyOnClose
        centered
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={672}
      >
        <div className={styles['verify-title']}>
          <div className={styles['title-inner']}>
          正在授权
            <img src={wechatImg} alt='' style={{ height: '20px', margin: '0 4px' }}/>
          与
            <img src={gerlunImg} alt='' className={styles['gerlun-img']}/>
          进行绑定
          </div>
          <div className={styles['separator']}></div>
        </div>
        <div className={styles['verify-container']}>
          <div className={styles['box-card']}>
            <div className={styles['card-head-title']}>
              <span>注册新账号</span>
            </div>
            <p className={styles['card-p']}>
            如果您还未注册过概而论平台，通过此流程进行账号注册并与微信号完成绑定
            </p>
            <div className={styles['button-bar']}>
              <Button type='primary' size='large' onClick={() => handleRegister()} className={styles['card-btn']}>注册</Button>
            </div>
          </div>
          <div className={styles['divide']}></div>
          <div className={styles['box-card']}>
            <div className={styles['card-head-title']}>
              <span>绑定已有账号</span>
            </div>
            <p className={styles['card-p']}>
            如果您已注册过概而论平台的账号，通过此流程可以与微信完成绑定
            </p>
            <div className={styles['button-bar']}>
              <Button type='primary' size='large' onClick={() => handleBind() } className={styles['card-btn']}>绑定</Button>
            </div>
          </div>
        </div>
        <div className={styles['verify-tip']}>
        通过以上两种方式，均可使微信号与概而论帐号完成绑定，再次使用微信登录时将直接登录绑定的概而论账号。
        </div>
      </Modal>
      <WechatBind ref={wechatBindRef} binded={handleWechatBinded}/>
    </Fragment>
  )
}

export default forwardRef(WechatVerify)
